module.exports = __webpack_public_path__ + "static/media/carte-identite.d058ce1b.svg";